module.exports = __webpack_public_path__ + "img/baharain-1.f8d02817.png";